/**
 * Log fence.
 *
 * The machine's own words, in a sunken slab, in mono, unreflowed. It is the
 * one place in the product where the interface stops paraphrasing, which is
 * exactly why it gets no styling opinion beyond a surface step and a hairline:
 * a person opens this because they stopped trusting the friendly summary, and
 * a decorated log would not help with that.
 *
 * Two details that are not decoration:
 *   - the slab is a focusable region with a name, because a scrollable box
 *     that a keyboard cannot reach is a box a keyboard user cannot read;
 *   - lines are never wrapped. A wrapped build log misaligns the caret line
 *     under the token it points at, and that caret is the whole diagnosis.
 */

import '../../styles/components/log-fence.css';

export interface LogFenceProps {
  /** Names the region for a screen reader: "Build log". */
  label: string;
  text: string;
  /** Taller, for a log that is the subject of the screen rather than a detail. */
  size?: 'md' | 'lg';
}

export function LogFence({ label, text, size = 'md' }: LogFenceProps) {
  return (
    <pre className="fence mono" data-size={size} role="region" aria-label={label} tabIndex={0}>
      {text}
    </pre>
  );
}
